import React, { Suspense } from "react";
import { graphql, useFragment } from "react-relay";

import { LoadingSpinner } from "../ui/loading-spinner";
import { AlertResponderJobRun_jobRun$key } from "./__generated__/AlertResponderJobRun_jobRun.graphql";
import { AlertResponderConversationWithRefetch } from "./AlertResponderConversationWithRefetch";

// Refetchable fragment for the job run
const alertResponderJobRunFragment = graphql`
  fragment AlertResponderJobRun_jobRun on GraphQLJobRun {
    outputJson
    status
    llmConversation {
      ...AlertResponderConversationWithRefetch_llmConversation
    }
  }
`;

export interface AlertResponderJobRunProps {
  /** The job run data */
  jobRun: AlertResponderJobRun_jobRun$key;
}

export function AlertResponderJobRun({
  jobRun: jobRunData,
}: AlertResponderJobRunProps) {
  const jobRun = useFragment(alertResponderJobRunFragment, jobRunData);

  if (!jobRun.llmConversation) {
    return null;
  }

  return (
    <Suspense
      fallback={
        <div className="flex justify-center p-4">
          <LoadingSpinner />
        </div>
      }
    >
      <AlertResponderConversationWithRefetch
        llmConversation={jobRun.llmConversation}
        outputJson={jobRun.outputJson}
        status={jobRun.status}
      />
    </Suspense>
  );
}